interface LoginDetails {
   from?: string;
   newUser?: boolean;
}

export function loginAnalyticsEvent({ from, newUser }: LoginDetails): {
   eventCategory: string;
   eventAction: string;
} | null {
   const loginType = newUser ? 'Join' : 'Log In';

   const eventAction = (() => {
      switch (from) {
         case 'google': {
            return loginType + ' - Google Sign-in';
         }
         case 'facebook': {
            return loginType + ' - Facebook Sign-in';
         }
         case 'apple': {
            return loginType + ' - Apple Sign-in';
         }
         case 'register': {
            return loginType + ' - Email Sign-up';
         }
         case 'email': {
            return loginType + ' - Email Sign-in';
         }
         // The code endpoints fix the direction: registerWithCode succeeds
         // only by creating the account, loginWithCode never creates one.
         case 'registerWithCode': {
            return 'Join - Email Code';
         }
         case 'loginWithCode': {
            return 'Log In - Email Code';
         }
         default: {
            return null;
         }
      }
   })();

   if (!eventAction) {
      return null;
   }

   return {
      eventCategory: eventAction.startsWith('Join') ? 'Join' : 'Log In',
      eventAction,
   };
}
